"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Breaks all non standard word breaks in a string returning a space instead. Will break:
 *  - camelCase
 *  - hyphenated-words
 *  - underscored_word
 *  - period.breaks
 *  - Basically any!special@character=break......and#;[]any----combo+length
 *  - Keeps apostrophes in words, e.g. don't, wouldn't etc.
 *
 * Will also remove any "social" special characters at the start of a word. E.g.:
 *  - @username -> username
 *  - #hashtag! -> hashtag!
 *
 * @param text
 */
exports.default = (text) => {
    let nonStandardWordBreaks;
    nonStandardWordBreaks = text.replace(/([a-z])([A-Z])/g, '$1 $2');
    nonStandardWordBreaks = nonStandardWordBreaks.replace(/([a-zÀ-ž])[!"£$%^&*()=+[\]{};:@#~\\|,.<>/?_-]+([a-zÀ-ž])/gi, '$1 $2');
    nonStandardWordBreaks = nonStandardWordBreaks.replace(/[@#]([À-ža-zA-Z0-9]+)/g, '$1');
    return nonStandardWordBreaks;
};
